//export const API_DOMAIN = "https://solaceimaging-api-stg.herokuapp.com";
export const API_DOMAIN = "https://api.solaceimaging.com";
export const API_ROUTE = API_DOMAIN + "/api/";
